<div mat-dialog-title class="full-width">
  <div class="full-width flex-row">
    <h3>Bulk File Upload</h3>
    <mat-icon (click)="ref.close()" class="clickable push-right">close</mat-icon>
  </div>
</div>

<mat-dialog-content>
  <div>
    <li>- Filename uses underscore delimiters</li>
    <li>- First value is an abbreviation for the dataset tag (e.g. 'LSM' => 'Mosaic', 'LSHD' => 'LandScan HD')</li>
    <li>- Second value is ISO 3166-3 code for country (e.g. 'USA' => 'United States', 'AZE' => 'Azerbaijan')</li>
    <li>- Third value is version with 'v1' being ignored in the naming. (e.g. 'LSM_AZE_v1.zip' => 'Mosaic Azerbaijan',
      'LSM_AZE_v2.zip' => 'Mosaic Azerbaijan (v2)')
    </li>
  </div>
  <div class="flex-row gap-10 padding-10 flex-align-start-center" *ngIf="request.itemsToPrepareForUpload.length === 0">
    <mat-form-field appearance="outline" class="name-input">
      <mat-label>Name Prefix</mat-label>
      <input matInput [(ngModel)]="request.namePrefix"/>
      <mat-hint>(e.g. 'Mosaic' => 'Mosaic Country Name')</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Tag</mat-label>
      <mat-select [(value)]="request.initialTags" multiple panelClass="fit-content">
        <mat-option *ngFor="let tag of tags" [value]="tag">{{ tag }}</mat-option>
      </mat-select>
      <mat-hint>Choose Tag if not in filename</mat-hint>
    </mat-form-field>

    <mat-form-field class="contributor-input" appearance="outline">
      <mat-label>Assignee</mat-label>
      <input matInput
             [matAutocomplete]="contributorAutoComplete"
             [formControl]="contributorControl">
      <mat-autocomplete #contributorAutoComplete="matAutocomplete" panelWidth="500">
        <mat-option *ngFor="let user of filteredContributors | async"
                    class="white-space-no-wrap"
                    [value]="concatName( user )"
                    (onSelectionChange)="selectContributor(user)">
          {{ displayUserInfo(user) }}
        </mat-option>
      </mat-autocomplete>
      <mat-hint>Optional</mat-hint>
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="chooseFiles()"
            matTooltip="Please choose all files at once"
            [class.soft-disabled]="request.itemsToPrepareForUpload.length > 0 || !readyForFiles()">
      <mat-icon>cloud_upload</mat-icon>
      Choose Files
    </button>
  </div>
  <div class="error-fg" *ngIf="!readyForFiles()">
    Enter a prefix and a choose a contributor
  </div>
  <input type="file" multiple (change)="onFilesPicked($event.target.files)" accept=".zip,.gz,.tar.gz,.tgz"
         class="display-none" #fileInput>
  <mat-table [dataSource]="request.itemsToPrepareForUpload" *ngIf="request.itemsToPrepareForUpload?.length > 0">

    <ng-container matColumnDef="tags">
      <mat-header-cell *matHeaderCellDef>Tags</mat-header-cell>
      <mat-cell *matCellDef="let t">
        {{ t.tags }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
      <mat-cell *matCellDef="let t">
        <div *ngIf="t.isUploading() && t.uploadProgress > 0" class="flex-column flex-align-center-stretch gap-5">
          Uploading...
          <mat-progress-bar mode="determinate" [value]="t.uploadProgress" class="full-width"></mat-progress-bar>
        </div>
        <div *ngIf="t.isComplete()" class="flex-row flex-align-start-center gap-5">
          <mat-icon class="success-fg">check_circle</mat-icon>
          Complete!
        </div>
        <div *ngIf="t.hasError()" class="flex-row flex-align-start-center gap-5">
          <mat-icon class="error-fg">error</mat-icon>
          {{ t.bulkUploadErrorMessage }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="filename">
      <mat-header-cell *matHeaderCellDef>Filename</mat-header-cell>
      <mat-cell *matCellDef="let t">
        {{ t.originalFilename }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
      <mat-cell *matCellDef="let t">
        <mat-form-field>
          <input matInput [(ngModel)]="t.name">
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let t; columns: displayedColumns;"></mat-row>
  </mat-table>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="full-width flex-row flex-align-end-center gap-10" *ngIf="request.itemsToPrepareForUpload?.length > 0">
    <div class="flex-row flex-align-start-center gap-5" *ngIf="uploading">
      <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
      Uploading Files...
    </div>
    <button *ngIf="request.itemsToPrepareForUpload?.length > 0"
            mat-raised-button
            (click)="uploadAndSave()"
            color="primary"
            [class.soft-disabled]="haveUploaded || uploading || request.itemsToPrepareForUpload.length === 0">
      <mat-icon>done</mat-icon>
      Upload Files And Save
    </button>
  </div>
</mat-dialog-actions>

